import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const LineGraph14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.8689 5.04878L12.6241 2.41603L11.376 1.58398L9.74324 4.03309L8.73022 3.52659C8.16637 3.24466 7.48082 3.42672 7.13114 3.95124L5.74324 6.03309L4.73022 5.52659C4.16637 5.24466 3.48082 5.42672 3.13114 5.95124L1.37598 8.58398L2.62405 9.41603L4.25679 6.96692L5.26981 7.47343C5.83366 7.75536 6.51921 7.5733 6.86889 7.04878L8.25679 4.96692L9.26981 5.47343C9.83366 5.75536 10.5192 5.5733 10.8689 5.04878Z'
      fill='currentColor'
    />
    <path d='M13 11.25H1V12.75H13V11.25Z' fill='currentColor' />
  </Svg>
);

LineGraph14.displayName = 'LineGraph14';
export default LineGraph14;
